import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { VerifastIFrameResponse } from 'app/interface/verifastIframeResponse';
import { ErrorService } from 'services/error.service';
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-verifast-verify',
  templateUrl: './verifast-verify.component.html',
  styleUrls: ['./verifast-verify.component.css']
})
export class VerifastVerifyComponent implements OnInit {
  isLoading: boolean = true;
  failedResult: boolean = false;
  iFrameURL = null;
  sessionComplete: boolean = false;

  constructor(private eventEmitterService: EventEmitterService, private prospectService: ProspectService, public router: Router, private errorService: ErrorService, private splashService: SplashService, private sanitizer: DomSanitizer) {
    // in case someone navigated here from application process
    localStorage.removeItem("ApplicationWorkflow");
    this.eventEmitterService.selfTourStepChange(1);
    this.prospectService.GetVerifastURL(false, null, "SelfTour").subscribe(res => this.proccesVerifastURL(res), err => this.errorService.showError("Error initiating Verifast."))
  }

  getVerifastUrl = () => {
    this.prospectService.GetVerifastURL(false, null, "SelfTour").subscribe(res => this.proccesVerifastURL(res), err => this.errorService.showError("Error initiating Verifast."))
  }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
  }

  proccesVerifastURL = (res: VerifastIFrameResponse) => {
    if (res.IFrameUrl) {
      this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(res.IFrameUrl);
      localStorage.setItem("verifastSessionId", res.SessionId);
      this.isLoading = false;
    }
    else {
      this.errorService.showError("Error initiating Verifast.");
    }
  }

  setSessionComplete = (value: boolean) => {
    this.sessionComplete = value;
  }

  setIsLoading = (loading: boolean) => {
    this.isLoading = loading;
  }

  setfailedResult = (loading: boolean) => {
    this.failedResult = loading;
  }
}
